export function useContactUs() {
  return {
    url: 'https://help.onekey.so/hc/requests/new',
  };
}
